import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { merge } from 'lodash-es';
import { ApiResponse } from '../../../classes/api-response';
import { SnackService } from '../../../services/snack.service';
import { BillingItems } from 'src/app/model/billingItems';
import { BillingItemsService } from 'src/app/services/billing-items.service';
import { environment } from 'src/environments/environment';
import { PublicService } from 'src/app/services/public.service';
import { BillingSetup } from 'src/app/model/billingSetup';
import { MatTableDataSource } from '@angular/material/table';
import { BillingSetupService } from "../../../services/billing-setup.service";
import { UpdateBillingDialogComponent } from '../update-billing-dialog/update-billing-dialog.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { DialogsService } from 'src/app/services/dialogs.service';
import { catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { Constants } from "../../../utils/constants";
import { AuthService } from 'src/app/services/auth.service';




@Component({
  selector: 'aw-edit-form-setup',
  templateUrl: './edit-form-setup.component.html',
  styleUrls: ['./edit-form-setup.component.scss']
})
export class EditFormSetupComponent implements OnInit {

  @Output() saved = new EventEmitter<void>();
  @Output() canceled = new EventEmitter<void>();
  saving = false;
  displayedColumnsItems = ['description', 'percentage', 'unitCost', 'units', 'invoicePeriod', 'Change', 'Delete'];
  billingItem$!: Observable<BillingItems[]>;
  dataSource!: MatTableDataSource<any>;
  hiddenPartner = true;
  hiddenBox = true;
  hiddenResearcher = true;
  loadingItems = false;
  roles = Constants.roles;
  loggedUser?: any;
  statusMessage!: string;
  generalError?: ApiResponse;
  billingSetupForm: UntypedFormGroup;
  selectedItem: BillingItems | undefined;
  disabled = false;
  isDisabled = Boolean;
  disabledItemId: number[] = [];
  months: number[] = [1, 3, 6, 9, 12];
  @Input() isRegistrationRequest = false;
  recaptchaKey = environment.captchaKey;
  radioTypeAnticipated = false;
  radioTypePostponed = false;
  selectMonth = 0;
  filteredItems: BillingItems[] = [];
  billingSetupId: number | undefined;
  items?: Array<BillingItems> = [];
  item?: Array<BillingItems> = [];
  partner = false;

  constructor(public dialog: MatDialog,
    private authService: AuthService,
    private changeDecRef: ChangeDetectorRef,
    private billingItemService: BillingItemsService,
    private snackService: SnackService,
    private _formBuilder: UntypedFormBuilder,
    public snackBarService: SnackService) {
    this.loggedUser = this.authService.loggedUser();
    this.billingItem$! = new Observable<BillingItems[]>();
    this.billingSetupForm = this._formBuilder.group(
      {

        id: new UntypedFormControl({ value: 0, disabled: !(this.loggedUser.role === this.roles.admin) },
          [
            // Validators.required
          ]
        ),
        addressLine1: new UntypedFormControl({ value: '', disabled: !(this.loggedUser.role === this.roles.admin) },
          [
            // Validators.required
          ]
        ),

        city: new UntypedFormControl({ value: '', disabled: !(this.loggedUser.role === this.roles.admin) },
          [
            // Validators.required
          ]
        ),
        codeSDI: new UntypedFormControl({ value: '', disabled: !(this.loggedUser.role === this.roles.admin) },
          [
            // Validators.required
          ]
        ),
        country: new UntypedFormControl({ value: '', disabled: !(this.loggedUser.role === this.roles.admin) },
          [
            // Validators.required
          ]
        ),
        description: new UntypedFormControl({ value: '', disabled: !(this.loggedUser.role === this.roles.admin) },
          [
            // Validators.required,
          ]
        ),
        email: new UntypedFormControl({ value: '', disabled: !(this.loggedUser.role === this.roles.admin) },
          [
            // Validators.required,
            Validators.email
          ]
        ),
        identifier: new UntypedFormControl({ value: '', disabled: !(this.loggedUser.role === this.roles.admin) },
          [
            // Validators.required
          ]
        ),
        pec: new UntypedFormControl({ value: '', disabled: !(this.loggedUser.role === this.roles.admin) },
          [
            // Validators.required,
            Validators.email
          ]
        ),
        phone: new UntypedFormControl({ value: '', disabled: !(this.loggedUser.role === this.roles.admin) },
          [
            // Validators.required
          ]
        ),
        vatNumber: new UntypedFormControl({ value: '', disabled: !(this.loggedUser.role === this.roles.admin) },
          [
            // Validators.required
          ]
        ),
        zipCode: new UntypedFormControl({ value: '', disabled: !(this.loggedUser.role === this.roles.admin) },
          [
            // Validators.required
          ]
        ),
        month: new UntypedFormControl({ value: '', disabled: !(this.loggedUser.role === this.roles.admin) },
          [
            // Validators.required
          ],
        ),
        type: new UntypedFormControl({ value: 0, disabled: !(this.loggedUser.role === this.roles.admin) })


      }
    );


    this.items = [];
  }
  _items = new BillingSetup();

  @Input() set billingSetup(value: BillingSetup) {
    console.log('value', value);
    this._items = value;

    this._items = merge(new BillingSetup(), value);
    this.items = value.billingItems;

    this.dataSource = new MatTableDataSource(this.items);
    console.log('dataSource', this.dataSource);
    if (typeof value.month !== "undefined" && value.month != 0) {
      this.partner = true;
      this.selectMonth = value.month;
      if (typeof value.type && value.type === 1) {
        this.radioTypeAnticipated = true;
      }
      if (typeof value.type && value.type == 2) {
        this.radioTypePostponed = true;
      }
      console.log(this.partner);
    }
    this.billingSetupForm.patchValue(this._items);

  }

  testbedComparator(t1: BillingSetup, t2: BillingSetup): boolean {
    return t1 && t2 ? t1.id === t2.id : t1 === t2;
  }

  @Output() newItemEvent = new EventEmitter<string>();

  addNewItem(value: string) {
    this.newItemEvent.emit(value);
  }

  ngOnInit(): void {

    if (this.isRegistrationRequest) {
      this.billingSetupForm.addControl('recaptchaReactive', new UntypedFormControl(null));

      this.changeDecRef.detectChanges();
    }

  }

  saveEditSetup(): void {
    this.saving = true;

    const newSetup = merge(new BillingSetup(), this.billingSetupForm.value);
    this.billingItemService.updateBillingSetup(newSetup)
      .pipe(
        catchError(err => {
          console.log('Handling error locally and rethrowing it...', err);
          return throwError(err);
        })
      )
      .subscribe(() => {

        this.snackService.success('Billing updated!');

        this.saved.emit();

      },
        err => {
          this.snackService.error('oh gee, this is wrong and bad');

          console.log('err', err)
        }
      );

  }

  //material dialog
  openDialog(element: any): void {

  }
  deleteItems(item: BillingItems) {
    this.disabled = !(this.loggedUser.role === this.roles.admin);
    const id = item.id ?? -1;
    this.disabledItemId.push(id);

    this.billingItemService.deleteItem(<number>item.id)
      .subscribe(
        (res) => {
          this.disabled = !(this.loggedUser.role === this.roles.admin);
          this.snackService.success('Billing setup deleted!');

          this.disabledItemId.splice(this.disabledItemId.indexOf(id), 1);
          console.log(res);
        },
        (error) => {
          this.snackService.error(error.message);
          this.disabled = !(this.loggedUser.role === this.roles.admin);
          this.disabledItemId.splice(this.disabledItemId.indexOf(id), 1);
        },
        () => {
          this.snackService.success('Operation completed!');
          this.disabled = !(this.loggedUser.role === this.roles.admin);
          this.dataSource.data.splice(this.disabledItemId.indexOf(id), 1);
        });
    const index = this.dataSource.data.indexOf(item);
    this.dataSource.data.splice(index, 1);
    this.dataSource._updateChangeSubscription();
    this.disabled = !(this.loggedUser.role === this.roles.admin);
  }
  // res => console.log('HTTP response', res),
  // err => console.log('HTTP Error', err),
  // () => console.log('HTTP request completed.')

  updateBillingItem(billingItem: BillingItems) {
    this.disabled = !(this.loggedUser.role === this.roles.admin);

    this.billingItemService.updateItem(billingItem)
      .pipe(
        catchError(err => {
          console.log('Handling error locally and rethrowing it...', err);
          return throwError(err);
        })
      )
      .subscribe(
        () => {
          this.saving = false;
          this.snackService.success('Billing updated!');
          this.saved.emit();
        },
        error => {
          this.saving = false;
          this.snackService.error(error.message);
          this.generalError = error;
          console.log(error, 'error');
        },

      )


  }


}

